import { Dispatch } from 'react';
import { CoreApi } from '../../../api/api.apiclient';
import { DeskOpeningRequest } from '../../../api/core/core.types';
import {
  DeleteDeskOpening,
  DELETE_DESK_OPENING,
  GetDeskOpeningListActuion,
  GET_DESK_OPENING_LIST,
  PostDeskOpeningAction,
  POST_DESK_OPENING,
  PutDeskOpeningAction,
  PUT_DESK_OPENING
} from '../types/deskopening.types';


export const getDeskOpeningList = (deskCode: string) => async (dispatch: Dispatch<GetDeskOpeningListActuion>) => {
  const response = await CoreApi.DeskOpenings.listAllDeskOpenings(deskCode);

  dispatch({
    type: GET_DESK_OPENING_LIST,
    payload: {
      deskOpenings: response
    }
  });
};

export const addNewDeskOpening = (request: DeskOpeningRequest, deskCode: string) => async (dispatch: Dispatch<PostDeskOpeningAction>) => {
  const response = await CoreApi.DeskOpenings.addNewDeskOpening(request, deskCode);

  dispatch({
    type: POST_DESK_OPENING,
    payload: {
      success: true,
      newDeskOpening: response.data
    }
  });
};

export const deleteDeskOpening = (id: number, deskCode: string) => async (dispatch: Dispatch<DeleteDeskOpening>) => {
  await CoreApi.DeskOpenings.deleteDeskOpening(id, deskCode);
  dispatch({
    type: DELETE_DESK_OPENING,
    payload: {
      success: true
    }
  });
};

export const editDeskOpening = (id: number, request: DeskOpeningRequest, deskCode: string) => async (dispatch: Dispatch<PutDeskOpeningAction>) => {
  const response = await CoreApi.DeskOpenings.editDeskOpening(id, request, deskCode);

  dispatch({
    type: PUT_DESK_OPENING,
    payload: {
      selectedDeskOpening: response.data
    }
  });
};
